(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creative-library"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hy-library').forEach((library) => {
    const tabs = library.querySelectorAll('[data-library-tab]')
    const panels = library.querySelectorAll('[data-library-panel]')
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          const selected = item === tab
          item.classList.toggle('is-active', selected)
          item.setAttribute('aria-selected', String(selected))
          item.tabIndex = selected ? 0 : -1
        })
        panels.forEach((panel) => { panel.hidden = panel.dataset.libraryPanel !== tab.dataset.libraryTab })
      })
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return
        event.preventDefault()
        const currentIndex = [...tabs].indexOf(tab)
        let nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : currentIndex + (event.key === 'ArrowRight' ? 1 : -1)
        nextIndex = (nextIndex + tabs.length) % tabs.length
        tabs[nextIndex].focus()
        tabs[nextIndex].click()
      })
    })

    const favoritesContainer = library.querySelector('[data-library-favorites]')
    if (!favoritesContainer) return
    const renderFavorites = () => {
      let favorites = []
      try { favorites = JSON.parse(window.localStorage.getItem('hytrape:creative-favorites') || '[]') } catch (error) { favorites = [] }
      if (!favorites.length) {
        favoritesContainer.replaceChildren(library.querySelector('[data-library-favorites-empty]').content.cloneNode(true))
        return
      }
      favoritesContainer.replaceChildren(...favorites.map((favorite) => {
        const article = document.createElement('article')
        article.className = 'hy-library-favorite'
        const link = document.createElement('a')
        link.href = favorite.url
        if (favorite.image) {
          const image = document.createElement('img')
          image.src = favorite.image
          image.alt = ''
          image.loading = 'lazy'
          link.append(image)
        }
        const content = document.createElement('div')
        const title = document.createElement('strong')
        title.textContent = favorite.title
        const price = document.createElement('span')
        price.textContent = favorite.price
        content.append(title, price)
        link.append(content)
        article.append(link)
        return article
      }))
    }
    renderFavorites()
    window.addEventListener('hytrape:favorites-updated', renderFavorites)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-community"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hy-review-carousel]').forEach((carousel) => {
    const enhanceReviews = () => {
      const productLabel = carousel.dataset.productLabel || '';
      carousel.querySelectorAll('.jdgm-carousel-item').forEach((item) => {
        if (item.dataset.hyEnhanced === 'true') return;
        item.dataset.hyEnhanced = 'true';

        const reviewer = item.querySelector('.jdgm-carousel-item__reviewer-name');
        const reviewerWrapper = item.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
        if (reviewer && reviewerWrapper) {
          const initials = reviewer.textContent.trim().split(/\s+/).slice(0, 2).map((word) => word.charAt(0)).join('').toUpperCase();
          const avatar = document.createElement('span');
          avatar.className = 'hy-review-avatar';
          avatar.setAttribute('aria-hidden', 'true');
          avatar.textContent = initials || 'HY';
          reviewerWrapper.prepend(avatar);
        }

        const timestamp = item.querySelector('.jdgm-carousel-item__timestamp');
        if (timestamp && timestamp.dataset.time) {
          const dateParts = timestamp.dataset.time.split('/');
          if (dateParts.length === 3) {
            const reviewDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
            timestamp.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { month: 'short', year: 'numeric' }).format(reviewDate);
          }
        }

        const productLink = item.querySelector('.jdgm-carousel-item__product');
        if (productLink) {
          productLink.dataset.hyProductLabel = productLabel;
          const productImage = productLink.querySelector('img');
          if (productImage) {
            if (!productImage.src && productImage.dataset.src) productImage.src = productImage.dataset.src;
            if (!productImage.srcset && productImage.dataset.srcset) productImage.srcset = productImage.dataset.srcset;
            productImage.loading = 'lazy';
            productImage.alt = '';
          }
        }
      });

      const wrapper = carousel.querySelector('.jdgm-carousel__item-wrapper');
      const previous = carousel.querySelector('.jdgm-carousel__left-arrow');
      const next = carousel.querySelector('.jdgm-carousel__right-arrow');
      if (previous) {
        previous.setAttribute('role', 'button');
        previous.setAttribute('aria-label', carousel.dataset.previousLabel || 'Previous reviews');
        if (!previous.dataset.hyScrollControl) {
          previous.dataset.hyScrollControl = 'true';
          previous.addEventListener('click', (event) => {
            event.preventDefault();
            wrapper?.scrollBy({ left: -(wrapper.clientWidth * .82), behavior: 'smooth' });
          });
        }
      }
      if (next) {
        next.setAttribute('role', 'button');
        next.setAttribute('aria-label', carousel.dataset.nextLabel || 'Next reviews');
        if (!next.dataset.hyScrollControl) {
          next.dataset.hyScrollControl = 'true';
          next.addEventListener('click', (event) => {
            event.preventDefault();
            wrapper?.scrollBy({ left: wrapper.clientWidth * .82, behavior: 'smooth' });
          });
        }
      }
    };

    enhanceReviews();
    new MutationObserver(enhanceReviews).observe(carousel, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-why-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hytrape-compare')) {
    customElements.define('hytrape-compare', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="range"]');
        if (!this.input) return;
        this.input.addEventListener('input', () => this.style.setProperty('--position', `${this.input.value}%`));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-digital-cart"]) return;
  try {
    
  (() => {
    const update = () => {
      const consent = document.querySelector('[data-digital-consent]');
      const express = document.querySelector('[data-digital-express]');
      if (!consent || !express) return;
      express.classList.toggle('is-locked', !consent.checked);
      express.setAttribute('aria-disabled', consent.checked ? 'false' : 'true');
    };
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-digital-consent]')) update();
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-digital-express]')) return;
      const consent = document.querySelector('[data-digital-consent]');
      if (consent && !consent.checked) {
        event.preventDefault();
        event.stopPropagation();
        consent.focus();
        consent.reportValidity();
      }
    }, true);
    document.addEventListener('cart:updated', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketplace-creator-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hy-creator-directory').forEach((directory) => {
    const buttons = directory.querySelectorAll('[data-creator-filter]')
    const cards = directory.querySelectorAll('[data-creator-discipline]')
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('is-active'))
        button.classList.add('is-active')
        cards.forEach((card) => { card.hidden = button.dataset.creatorFilter !== 'all' && card.dataset.creatorDiscipline !== button.dataset.creatorFilter })
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketplace-seller-dashboard"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-submission]').forEach((form) => {
    const checklist = form.querySelector('[data-submission-checklist]')
    const score = form.querySelector('[data-submission-score]')
    const bar = form.querySelector('[data-submission-bar]')
    const status = form.querySelector('[data-submission-status]')
    if (!checklist) return
    checklist.addEventListener('change', () => {
      const checked = checklist.querySelectorAll('input:checked').length
      const complete = checked === 6
      score.textContent = `${checked}/6`
      bar.style.setProperty('--submission-progress', `${checked / 6 * 100}%`)
      status.textContent = complete ? form.dataset.completeLabel : form.dataset.incompleteLabel
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketplace-seller-program"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-seller-application]').forEach((form) => {
    if (form.dataset.enhanced === 'true') return
    form.dataset.enhanced = 'true'
    const done = form.querySelector('.hy-seller-application__done')
    if (done) {
      done.focus({ preventScroll: true })
      return
    }
    let currentStep = 1
    const steps = Array.from(form.querySelectorAll('[data-application-step]'))
    const progress = Array.from(form.querySelectorAll('[data-progress-step]'))
    const previousButton = form.querySelector('[data-step-previous]')
    const nextButton = form.querySelector('[data-step-next]')
    const submitButton = form.querySelector('[data-step-submit]')

    const renderStep = (focusLegend = false) => {
      steps.forEach((step) => { step.hidden = Number(step.dataset.applicationStep) !== currentStep })
      progress.forEach((item) => {
        const number = Number(item.dataset.progressStep)
        item.classList.toggle('is-active', number === currentStep)
        item.classList.toggle('is-complete', number < currentStep)
        if (number === currentStep) item.setAttribute('aria-current', 'step')
        else item.removeAttribute('aria-current')
      })
      previousButton.hidden = currentStep === 1
      nextButton.hidden = currentStep === steps.length
      submitButton.hidden = currentStep !== steps.length
      if (focusLegend) {
        const legend = steps[currentStep - 1].querySelector('legend')
        legend?.setAttribute('tabindex', '-1')
        legend?.focus({ preventScroll: true })
      }
    }

    nextButton.addEventListener('click', () => {
      const activeStep = steps[currentStep - 1]
      const fields = Array.from(activeStep.querySelectorAll('input,select,textarea'))
      const invalidField = fields.find((field) => !field.checkValidity())
      if (invalidField) {
        invalidField.reportValidity()
        return
      }
      currentStep = Math.min(steps.length, currentStep + 1)
      renderStep(true)
      form.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })

    previousButton.addEventListener('click', () => {
      currentStep = Math.max(1, currentStep - 1)
      renderStep(true)
    })

    const checklist = form.querySelector('[data-quality-checklist]')
    const score = form.querySelector('[data-quality-score]')
    checklist?.addEventListener('change', () => {
      score.textContent = `${checklist.querySelectorAll('input:checked').length}/5`
    })
    renderStep()
  })

  document.querySelectorAll('[data-seller-sticky]').forEach((sticky) => {
    const root = sticky.closest('.hy-seller-program')
    const hero = root.querySelector('.hy-seller-hero')
    const watched = [root.querySelector('#seller-application'), root.querySelector('.hy-seller-final')]
    if (!hero || !('IntersectionObserver' in window)) return
    const state = { hero: true, application: false, final: false }
    const update = () => sticky.classList.toggle('is-visible', !state.hero && !state.application && !state.final)
    new IntersectionObserver((entries) => { state.hero = entries[0].isIntersecting; update() }, { threshold: 0.15 }).observe(hero)
    ;['application', 'final'].forEach((key, index) => {
      if (!watched[index]) return
      new IntersectionObserver((entries) => { state[key] = entries[0].isIntersecting; update() }, { threshold: 0.05 }).observe(watched[index])
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-digital-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-before-after]').forEach((comparison) => {
    const range = comparison.querySelector('[data-before-after-range]');
    const layer = comparison.querySelector('[data-before-after-layer]');
    const divider = comparison.querySelector('[data-before-after-divider]');
    if (!range || !layer || !divider) return;
    range.addEventListener('input', () => {
      const value = `${range.value}%`;
      layer.style.clipPath = `inset(0 ${100 - range.value}% 0 0)`;
      divider.style.left = value;
    });
  });

  document.querySelectorAll('[data-vector-tester]').forEach((tester) => {
    const colorInput = tester.querySelector('[data-vector-color]');
    const preview = tester.querySelector('[data-vector-preview]');
    if (!colorInput || !preview) return;
    colorInput.addEventListener('input', () => { preview.style.backgroundColor = colorInput.value; });
  });

  } catch(e) { console.error(e); }
})();
})();
